import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-date',
  template: `
    {{note.createdAt * 1000 | date:'dd.MM.y H:mm'}}
  `,
  styles: [
    `
    :host {
      font-size: 13px;
    }
  `
  ]
})
export class DateComponent {
  @Input() note;

  constructor() {}
}
